module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TWO")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Q")])]), _vm._v("uinn wasn’t happy when Shanna insisted on driving home, but he followed right behind her as they went the couple of blocks to her house. She lived in a nice, if older, suburb of Chicago, where the houses were small and the lots even smaller, yet well-groomed. He gripped the steering wheel tightly, anxious to get to the bottom of this.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The brief glimpse of fear in Shanna’s eyes tugged at him. He’d seen the same haunted expression in the young freshman’s eyes last night, after the attack. His stomach squeezed. He didn’t like the possibility of Shanna suffering a similar experience. Thankfully, the mystery man had only left a note and hadn’t touched her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Some people felt that campus police officers weren’t the real deal, hiding from the true crime that stalked the city streets. He’d done his stint as a city cop for over six years. Now he preferred to proactively protect the younger, innocent college kids rather than taking criminals off the street, knowing there was always another cop eager to take his place.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("He pulled into Shanna’s driveway right behind her, ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("and hurried out of his car to stop her from going inside. “Stay back. I want to check things out first.”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She pushed his hand away. “I’m a trained law-enforcement officer,” she protested.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, but I’m armed.” And he’d noticed she wasn’t, at least not at the restaurant. She had carried a gun while she was investigating the crime scene as all CSIs were required to do. But knowing she was a trained officer didn’t matter. For some reason, this woman raised his protective instincts to full alert.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stared at him for a long minute and then took a step back, allowing him to take the lead. While she hovered behind him, he took the key from her fingers and ventured inside. The layout was a simple ranch design; the side door entered into the kitchen. The front door opened into the living room, and then there was a short hallway leading to the bedrooms.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The light over the kitchen sink was burning bright so he swept his gaze over the room, listening intently. His gut told him the place was empty, but he went through each room anyway, just to make sure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he finished, he headed back to the kitchen. Three notes were sitting in the center of the table. He leaned over, read them and then looked up at her askance. “Have you called the police about these threats?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She winced and shook her head, her arms wrapped around her torso as if she were cold. “Not yet. I was going to, though. That last one came today. I mean, yesterday.” She frowned. “Actually, I don’t exactly know what day it came, because I sometimes forget to pick up the mail.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("“So you received a note and still drove out to meet ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("me tonight?” His fingers curled into helpless fists at her foolishness. “Are you crazy?”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her shrug was nonchalant. “Working on Brady’s case helped keep my mind off my problems.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A stalker wasn’t just any old problem. He was tempted to snap at her, but realized Shanna was a trained law-enforcement agent, just like he was. She could take care of herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So why did he want to do that for her?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Because he was tempted to pull her into the shelter of his arms in a gesture of comfort, he forced himself to stay where he was, keeping a safe distance between them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you have any idea who’s sending these?” he asked in a low tone. “A jilted boyfriend? Someone at work that you refused to go out with?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She made a strangled sound. “No. I haven’t been seeing anyone, no ex-boyfriends. No one’s been bothering me. My personal life is dull and uneventful. To be honest, I’ve already concluded the notes have to be related to one of my cases.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shouldn’t have been relieved to know there wasn’t a man in her life, just as he shouldn’t have noticed how vulnerable she’d looked when she’d admitted the boring details of her past. Why was such a pretty woman leading a dull and uneventful life? Her personal life was none of his business, but he wanted to know just the same. He kept his voice firm. “You need to call the police.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re the police,” she joked weakly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Shanna.” He moved closer, lifting his hand to brush her hair away from her cheek. “You know I don’t have jurisdiction here. You need to call this in, before this guy gets too close.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a moment she simply stared at him with something forlorn in her gaze, but then she pulled back and straightened her shoulders. “Don’t worry. I won’t let him get to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wanted to believe her. But that hint of vulnerability made him hesitate. Maybe because he was a pushover for a woman in distress. Yet she seemed just as determined to stand alone. A part of him admired her independence while another part of him was annoyed at her stubborn foolishness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you going to call the police?” he asked for the third time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not right now. It’s late. I’ll wait until the morning. This isn’t an emergency and there isn’t anything they’re going to be able to do about the notes tonight. Especially since I can’t even give them a reasonable description of the suspect.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He knew she was right, but that didn’t make it any easier for him to leave. He glanced around her small living room. “I don’t like leaving you here alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll be fine.” The underlying steel in her tone finally convinced him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay, but do me a favor.” He held her gaze, imploring her to listen to reason. “Close and lock every window.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She grimaced and nodded. “I like having the cool fresh air from outside coming through the windows, but I’ll manage without for tonight,” she reluctantly agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He waited until she’d gone through every room, closing and locking the windows. Standing in the kitchen, his gaze continued to linger on the notes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("Who could have sent them? And why? Someone ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("who liked to play games, obviously. Mind games. The thought caused a sick feeling to settle in his gut.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All set?” he asked when she came back toward him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes. Thanks for following me home.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re welcome.” He forced himself to walk toward the side door. “You have my cell-phone number. Promise you’ll call if you need anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She smiled. “Don’t worry. I’ll be fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He told himself she was right. She would be fine. Outside he paused and listened, satisfied to hear the dead bolt click into place. He headed toward his car, glancing back to look at her house. She’d shut off most of the lights, except maybe the one in her bedroom, which he couldn’t see from the street.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He slid behind the wheel and backed out of her driveway, intent on going home when he saw a car moving slowly down the street. Too slowly. Heart thudding in his chest, he pulled over to the side of the road, holding his breath as he waited. The car passed him by, turning into a driveway several houses down. The garage door opened, and the car disappeared inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Idiot,” he muttered to himself. He was exhausted, had been up for over forty hours straight, but he couldn’t just go home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shutting off the car, he pulled the key out of the ignition and leaned his seat as far back as it could go. He cracked the windows so he could hear better, knowing he was going to spend the night here, watching over Shanna, despite her refusal to accept his help.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was too tired to drive anyway.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("Slouched in his car, he stared at Shanna’s dark house, wondering about her. Why was she so alone when she lived in a nice neighborhood that seemed like the perfect place to raise a family? The pain shad")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("owing her eyes hadn’t all been from the notes, he was certain. Yet as much as he wanted to protect her, she seemed just as determined to brush off his help.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rubbing his eyes, he briefly wished for peace rather than being haunted by the demons in his past. His dad had been a city cop for years. Hunting drug runners, witnessing armed robberies and murders, had taken its toll. His dad had turned to booze, ignoring the abuse he’d inflicted on his body until one day Quinn had come home to find his dad crumpled on the bathroom floor, lying in a pool of blood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d called 911 but had already known it was too late. According to the coroner, his dad had been throwing up blood from some burst blood vessel in his esophagus, and had literally choked on it before he’d died.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The memory haunted him ever since.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Quinn had always avoided alcohol, but then he went a step further, giving up the stress of being a city cop to join the university campus police force. His mother had wanted him to get out of law enforcement altogether, claiming his dad’s job had ruined their marriage, but he couldn’t do it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a part of him that needed to know he made a difference in the world, no matter how small and insignificant it may be.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("His attraction to Shanna, though, forced him to remember all the reasons he veered away from relationships. He wasn’t a safe bet, and not just because of his family history of alcoholism. He knew from firsthand experience that women wanted a man who came home every night. Men who weren’t in danger. Men who didn’t obsess over their work. Even as a campus cop, he’d been drawn on by gang members with guns ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("more times than he could count. Most recently by two idiots who decided to rob the corner coffee shop.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Leslie had left him, just like his mother had left his father. Proving he was better off alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a sigh, he let his head fall back against the seat rest, unable to prevent himself from closing his eyes. He’d stay here outside Shanna’s place, making sure she called the police to report her stalker first thing in the morning. Once he was satisfied she’d taken steps to assure her safety, he’d go back to working Brady’s murder investigation where he’d left off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Finding out who’d killed Brady had to remain his top priority.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shanna didn’t sleep very well; the slightest noises kept waking her up. All because she’d let the creepy stalker get to her more than she’d wanted to admit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At least she’d held it together in front of Quinn. He was too attractive for her peace of mind. Not handsome per se, but definitely ruggedly attractive. On top of that, he’d been nice, supportive. Not that she needed his help.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What she needed was action. Today she’d get a full investigation going on this note-writing guy, whoever he was. Stalking was against the law, as were threats. She’d find this guy and hand him over to the police the first chance she had.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With renewed determination, she took a quick shower and spent a few minutes blow-drying her hair before heading to the kitchen, intending to brew a pot of coffee.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("As she walked past the entryway to the living room, she happened to glance through the large picture window overlooking the street. She froze, her ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("heart leaping into her throat when she noticed the SUV parked directly across the street from her house. The car stood out because her neighbors across the street were elderly and didn’t drive. Fearing the worst, she grabbed her cell phone and almost punched the numbers for 911 when she realized why the car looked familiar.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was the same car that had followed her home last night. The vehicle belonged to Quinn. Flipping her cell phone shut, she crossed over to the picture window in time to see Quinn yawning and stretching his arms over his head. While she was staring at him, he glanced toward her house, capturing her gaze. For a moment, the strange connection between them seemed to shimmer in the air.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Had he really slept out there all night? She was touched by his chivalry but was determined not to read more into his actions than the situation warranted. Uncertainly, she opened the front door. Was she supposed to invite him in after the way he’d slept in his car to protect her?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He climbed awkwardly from the car, his limbs obviously stiff from the cramped seat. But then he came straight toward her, meeting her halfway. “Morning, Shanna. Did you sleep well?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She tried to act nonchalant. “Better than you, I’d be willing to bet. Quinn, it was very sweet of you to sleep in your car, but I told you I’d be fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know, but I was too tired to drive,” he said, glancing longingly over her shoulder. “Is that coffee I smell?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("“Yes.” She felt bad about the exhaustion shadowing his features. As uncomfortable as she was having him ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("there, the least she could do was feed him. “Come on in, there’s plenty to share.”")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He followed her inside, crossing the living room to the kitchen. He took a seat at her table, and she could feel his gaze on her as she filled a mug from the coffeemaker. She couldn’t help feeling self-conscious with him there, maybe because she’d never had a man in her house. Ever.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She carefully set the mug on the table, thankful she didn’t spill. “Ah, do you like eggs? Because I have to tell you, there isn’t a huge variety of food to choose from.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Eggs would be great.” His stomach rumbled loudly, as if reinforcing his need for food. He flashed a sheepish grin and her heart did a funny little flip.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She squelched the reaction and quickly threw together scrambled eggs and toast. The sooner she gave him food, the sooner she could send him on his way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he’d finished the first cup of coffee, he came over to get a refill. His closeness was enough to rattle her, and she burned her thumb on the edge of the frying pan. She swallowed a yelp, thrusting her thumb under a stream of cold water. This was ridiculous; there was no reason to be nervous.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you all right?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Fine.” She forced a smile. “The eggs are just about ready.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks.” He carried his mug over to the table, and she handed him a plate full of eggs and toast. They ate in silence for a few minutes before Quinn spoke up. “You’re going to call the police when we’re finished with breakfast, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She barely refrained from rolling her eyes. The man sounded like a broken record. “Right.”")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As soon as she finished her meal, Shanna gave in and pulled out her cell phone. Considering she’d worked all day Sunday, she could afford to be a little late to work this morning. She had to look up the non-emergency number in the phone book and briefly explained her situation when one of the officers came on the line.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They’re sending someone over,” she said, hanging up a few minutes later. “They asked me to leave the card from last night under the windshield wiper.” She hadn’t touched the note, figuring the cops would want to see exactly where the guy had left it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good.” Quinn sat back, sipping his coffee as if he wasn’t in a hurry to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The police are on their way, Quinn. There’s no need for you to stay.” She carried her dirty dishes to the sink, cleaning up the remains of their breakfast mess. “You need to go home, get some decent sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How long before you get anything back from the lab?” he asked, ignoring her blatant hint urging him to go. “On the fingerprints and hair fibers?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We have lots of evidence to sift through. I’m afraid it will probably be awhile.” She understood how anxious he was for news, any news. She’d been on his side of the waiting game. It had only been in recent years that she’d learned how patience was a virtue. “I promise I’ll get in touch with you if we come up with anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced at her. “You know I’m not really involved in this investigation, except peripherally. All of your evidence needs to go to Hank Nelson.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("“I know.” She wrung out the dishrag and turned toward him, resting her hip against the counter. “But you’re the one who knows the students on campus, ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("right? Hank has to keep you involved in the investigation to a certain extent. Maybe we do have to give all the evidence to the lead homicide detective on the case, but I see no reason why the crime lab wouldn’t cooperate with the campus police, too.”")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He smiled and shrugged. “Hank probably won’t like it, but I’ll take anything you can give me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His appreciation warmed her heart. After the way he’d slept in his car, just to protect her, this was the least she could do in return. Besides, the homicide had taken place on his turf. She’d expect the same consideration in his shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Their gazes locked, and for a moment she felt as if she couldn’t breathe. She didn’t deserve to feel this attraction to him, but she couldn’t look away. If she were honest, she’d admit she intended to keep him in the loop because she wanted to see him again, not just because of professional courtesy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The ringing of her doorbell echoed through the house, breaking the moment. She swallowed hard and pushed away from the counter, crossing over to the living room to open the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The officers who stood there had their respective IDs ready, which she carefully inspected before allowing Officers Kappas and Jones inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Murphy?” Jones, the taller of the two, frowned when he recognized Quinn. “Haven’t seen you since your old man’s funeral.” His gaze landed on Shanna, frankly curious. “I—uh—didn’t know you were involved with anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Funeral? Shanna glanced at Quinn in surprise, but then flushed when she realized the two officers assumed she and Quinn were a couple. “He’s a friend,” she said quickly.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The last thing she needed were rumors going around about her and Quinn. How embarrassing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" would be.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We were at Karly’s Kitchen last night when Ms. Dawson saw a man loitering by her car,” Quinn said, as if sensing her discomfort. “I didn’t see him, but we found a white envelope with her name printed on the front in block letters, stuck under her windshield.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was grateful Quinn cut to the chase, putting the interview back on track.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ms. Dawson has received other notes, as well.” He picked up the three notes she’d left on the counter and handed them to the officers. “Shanna, when did you get the first note?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Two weeks ago.” She explained how the first note had actually showed up in her mailbox down at the CSI lab. The message read “Guilty as charged,” so she hadn’t really thought too much about it. “I guess I figured the sender was just someone dealing with a lot of anger. The second and third ones, though, were in my mailbox here at home.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her personal space. Her haven.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You dusted for fingerprints?” Kappas asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m a CSI—of course I dusted for prints. Didn’t find any, though. I also tried to narrow down the source of the paper, but it’s carried everywhere.” She lifted her palms helplessly. “Really, this could be related to any one of my cases, although the one I just wrapped up, the Markoviack murder, is the most likely one.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did the man by your car look at all familiar?” Jones took over the questioning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I only caught a glimpse, but didn’t recognize him at all.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("“You mentioned this being related to one of your ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("cases, like the Markoviack murder. Why does that one stand out in your mind?” Kappas asked.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She quickly explained about the last big case she’d worked on, how her evidence put Jessica Markoviack in prison. Both officers exchanged a look and agreed that Jessica’s former boyfriend was a possible culprit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where’s the fourth note now?” Jones asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She glanced at Quinn. “We left it beneath the windshield wiper. My car is in the garage.” Leading the way out the side door, to the detached garage where her Toyota Camry was parked, she gestured to the car.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The officers looked at the note, then used gloved hands to remove it from beneath the wiper blade. She took out her fingerprint kit and dusted both the note and the windshield for prints.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There weren’t any, just like the previous notes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jones opened the flap and removed the note. They crowded around to see what it said. “Next time, you’ll be alone,” Jones read out loud.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t get it,” Quinn muttered. “How did he know you were with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She couldn’t suppress a shiver, fear congealing in the bottom of her stomach. “Because he’s watching me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kappas and Jones exchanged a grim look. “I’ll recommend increased surveillance of this neighborhood, ma’am,” Jones said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sending a patrol car through every couple hours wasn’t going to prevent this guy from trying to get her, but she understood they were doing the best they could. “That’s fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, it’s not,” Quinn argued bluntly. “If this guy is watching you, he’ll know to hide from the police. You need a bodyguard. Or at least a comprehensive security system.”")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe.” She didn’t want to admit his idea had merit. “I’ll think about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Quinn looked as if he wanted to argue, but instead he turned toward the officers. “Anything else?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ms. Dawson might want to find a friend to stay with for a while,” Officer Jones said. “Being here alone is asking for trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Friends? She almost laughed. The only real friend she had was Megan O’Ryan, and she’d recently moved to Crystal Lake, Wisconsin. Megan had just gotten married, and after everything her friend had been through, Shanna couldn’t bring herself to dump her own troubles on Megan’s shoulders. Megan had barely survived being strangled by a serial killer. Worse, the killer was someone they knew. Raoul Lee was a brilliant scientist. Now he’d spend the rest of his life in jail. The cops waited expectantly, so she nodded. “I’ll see what I can do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The officers left, promising to be in touch if they found anything.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll follow you to work.” Quinn’s tone didn’t leave room for discussion.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His persistence was starting to annoy her. But rather than arguing, she gathered her work stuff together, including her shoulder holster. She sensed Quinn’s frustration as he stood watching her. Before she could get out the door, her cell phone rang.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She recognized Alan’s number from the lab. Setting her laptop case on the kitchen table, she answered the phone. “Do you have something for me, Al?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, uh, we got a hit on one of the fingerprints found at your college frat house crime scene.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("A hit on the fingerprints was good news. “Who is ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("it?” she asked eagerly, glancing at Quinn. An identity would get them one step closer to finding the killer.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you on your way here? Because I think we should talk in person.” He cleared his throat loudly. “The news is going to be a bit of a shock.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His tap-dancing around the issue only irritated her. “Just tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a pause. “Shanna, we have a set of fingerprints matching a child who’s been missing for fourteen years.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A child? Missing for fourteen years? No. Oh, no. Her stomach twisted, and little red dots swam in her vision. She grabbed the edge of the kitchen table and pushed the word through her tight throat. “Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your sister. Skylar Dawson.”")])])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page36"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89a23400","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459216273_ch02.vue
// module id = 81
// module chunks = 0